var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('SplineChart',{attrs:{"hcTitle":_vm.hcTitle,"hcSubtitle":_vm.hcSubtitle,"hcData":_vm.hcData,"AxisCategories":_vm.axisCategories,"xAxisTitle":_vm.xAxisTitle,"yAxisTitle":_vm.yAxisTitle}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }